import { render, staticRenderFns } from "./StampRally.vue?vue&type=template&id=22bdec19&"
import script from "./StampRally.vue?vue&type=script&lang=ts&"
export * from "./StampRally.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports